// src/pages/projects/container/ProjectMenu.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Menu, MenuItem, ListItemIcon, Divider, Typography, Fade,
  useTheme
} from '@mui/material';
import {
  Edit as EditIcon,
  Check as CheckIcon,
  Delete as DeleteIcon,
  Save as SaveIcon
} from '@mui/icons-material';

const ProjectMenu = ({ 
  anchorEl, 
  project, 
  onClose, 
  onDelete, 
  onStatusChange,
  onStartEditingTitle,
  onSaveAsTemplate
}) => {
  const theme = useTheme();
  
  // Early return if no project
  if (!project) return null;
  
  // Status menu items for reuse
  const statusItems = [
    { id: 'draft', label: 'Draft' },
    { id: 'planning', label: 'Planning' },
    { id: 'active', label: 'Active' },
    { id: 'on_hold', label: 'On Hold' },
    { id: 'completed', label: 'Completed' },
    { id: 'cancelled', label: 'Cancelled' }
  ];
  
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      TransitionComponent={Fade}
      sx={{ mt: 1 }}
      PaperProps={{
        elevation: 3,
        sx: { 
          width: 230,
          borderRadius: 1
        }
      }}
    >
      <MenuItem onClick={onStartEditingTitle}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        Rename project
      </MenuItem>
      
      <Divider />
      
      <Typography variant="caption" sx={{ px: 2, py: 0.5, display: 'block', color: 'text.secondary' }}>
        Status
      </Typography>
      
      {statusItems.map(status => (
        <MenuItem 
          key={status.id}
          onClick={() => onStatusChange(status.id)} 
          selected={project.status === status.id}
        >
          <ListItemIcon>
            {project.status === status.id && <CheckIcon fontSize="small" />}
          </ListItemIcon>
          {status.label}
        </MenuItem>
      ))}
      
      <Divider />
      
      <MenuItem component={Link} to={`/projects/${project._id}/edit`}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        Edit details
      </MenuItem>

      {onSaveAsTemplate && (
        <MenuItem onClick={onSaveAsTemplate}>
          <ListItemIcon>
            <SaveIcon fontSize="small" />
          </ListItemIcon>
          Save as Template
        </MenuItem>
      )}
      
      <MenuItem onClick={onDelete} sx={{ color: theme.palette.error.main }}>
        <ListItemIcon sx={{ color: theme.palette.error.main }}>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        Delete project
      </MenuItem>
    </Menu>
  );
};

export default ProjectMenu;